import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";
import DfStore from "@/vue/domain/store/df-store";
import { CONTAINER_TYPES } from "@/vue/infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfUser from "@/vue/domain/user/df-user";

@Component({
  components: {
    DfHeaderMobile: () => Utils.externalComponent2("df-header-mobile"),
    DfStoreCard: () => Utils.externalComponent2("df-store-card"),
    DfLoadingMask: () => import(/* webpackChunkName: 'df-loading-mask' */ "@/vue/components/df-loading-mask/df-loading-mask.vue"),
  },
})
export default class DfPageAccountCouponSavi extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;
  private saviError = false;

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get clubCardNumber(): string {
    return Utils.getPropertyValue(this.currentUser, Utils.PROPERTY_USER_CAMI_CARD_NUMBER, "STRING");
  }

  get currentUser(): DfUser {
    return this.$store.getters.user;
  }

  get enableSaviCoupon(): boolean {
    return Utils.enableSaviCoupon();
  }

  beforeMount() {
    if (this.currentUser) {
      if (this.enableSaviCoupon) {
        console.log("SMT: Savi coupon enabled");
      } else {
        this.goToStorePage(this.currentStore);
      }
    }
  }

  mounted() {
    this.handleSaviCoupon();
  }

  beforeDestroy() {
    document.removeEventListener("getSaviConsumerData", this.getSaviConsumerData);
    document.removeEventListener("getSaviGalleryLoaded", this.getSaviGalleryLoaded);
  }

  private handleSaviCoupon() {
    if (this.enableSaviCoupon && this.clubCardNumber) {
      this.saviError = false;
      const valassisScriptUtilitiesId = "ValassisScriptUtilities";
      if (!document.getElementById(valassisScriptUtilitiesId)) {
        this.service
          .getSaviEncrypt(`{"ID": "${this.clubCardNumber}"}`)
          .then((encryptedData: string) => {
            const script = document.createElement("script");
            script.id = valassisScriptUtilitiesId;
            script.type = "text/javascript";
            script.text = `
              function getConsumerData(loginRequired, setConsumerData) {
                console.log("SMT: Call getConsumerData internal", loginRequired, setConsumerData);
                setConsumerData("${encryptedData}");
                const event = new CustomEvent("getSaviConsumerData", {
                  detail: {
                    data: "getConsumerData done",
                  },
                });
                document.dispatchEvent(event);
              }
      
              function galleryLoaded() {
                console.log("SMT: Call galleryLoaded: external script");
                const event = new CustomEvent("getSaviGalleryLoaded");
                document.dispatchEvent(event);
              }
              `;
            document.body.appendChild(script);
            console.log("SMT: Utilities Savi iniettato nel body.");

            const valassisGalleryScriptId = "ValassisGalleryScriptId";
            if (!document.getElementById(valassisGalleryScriptId)) {
              const newScript = document.createElement("script");
              newScript.src = Utils.getSaviCouponScriptUrl();
              newScript.id = valassisGalleryScriptId;
              newScript.async = true;
              newScript.onload = () => {
                if ((<any>window).valassis) {
                  (<any>window).valassis.expand();
                }
              };
              this.$el.appendChild(newScript);
            }
          })
          .catch(() => {
            this.saviError = true;
          });
      } else {
        console.log("SMT: Utilities Savi già presenti.");
      }
      document.addEventListener("getSaviConsumerData", this.getSaviConsumerData);
      document.addEventListener("getSaviGalleryLoaded", this.getSaviGalleryLoaded);
    }
  }

  private getSaviConsumerData(data: any) {
    console.log("getSaviConsumerData", data.detail);
  }

  private getSaviGalleryLoaded(data: any) {
    console.log("SMT: Call galleryLoaded internal script");
  }

  private goToStorePage(store: DfStore) {
    this.$router.push({ name: "store", params: { storeAlias: store.alias } }).catch((err) => err);
  }

  private openMap() {
    window.open(`${Utils.GOOGLE_MAP_URL}${Utils.storeGoogleMapsCoordinates(this.currentStore)}`, "_blank");
  }
}
